import { Experiment } from '@cian/experiments/ab';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackClickQuickFilter } from './tracking';
import { QuickFilters as QuickFiltersWithIcons } from '../../components/QuickFilters';
import { QuickFilters as QuickFiltersWithImages } from '../../components/QuickFiltersRedesigned';
import { AUD_MOBILE_REDESIGN_MAINPAGE } from '../../constants/experiments';
import { IQuickFiltersBlock, IQuickFiltersRedesign } from '../../types/quickFilters';
import { IApplicationState } from '../../types/redux';
import { useApplicationContext } from '../ApplicationContext';

const QuickFiltersContainerComponent: React.FC = () => {
  const quickFiltersBlocks: IQuickFiltersBlock[] = useSelector(
    ({ quickFilters }: IApplicationState) => quickFilters.blocks,
  );
  const redesignedQuickFilters: IQuickFiltersRedesign | undefined = useSelector(
    ({ quickFilters }: IApplicationState) => quickFilters.redesign,
  );

  const { config } = useApplicationContext();
  const isNewbuildingEntryEnabled = Boolean(config.get<boolean>('Newbuilding.EntryPoint.Enabled'));

  const redesignContent = redesignedQuickFilters && (
    <QuickFiltersWithIcons
      filters={redesignedQuickFilters}
      trackClickQuickFilter={trackClickQuickFilter}
      isNewbuildingEntryEnabled={isNewbuildingEntryEnabled}
    />
  );

  return (
    <>
      <Experiment name={AUD_MOBILE_REDESIGN_MAINPAGE} group="A" default>
        <QuickFiltersWithImages
          filters={quickFiltersBlocks}
          trackClickQuickFilter={trackClickQuickFilter}
          isNewbuildingEntryEnabled={isNewbuildingEntryEnabled}
        />
      </Experiment>
      <Experiment name={AUD_MOBILE_REDESIGN_MAINPAGE} group="B">
        {redesignContent}
      </Experiment>
      <Experiment name={AUD_MOBILE_REDESIGN_MAINPAGE} group="C">
        {redesignContent}
      </Experiment>
    </>
  );
};

export const QuickFiltersContainer = React.memo(QuickFiltersContainerComponent);
